export default __webpack_public_path__ + "static/media/LightLogo.0a9b7a57.png";